import axios from 'axios'  //这里引入axios  mian无需再引
import Vue from "vue";    //引入Vue
Vue.prototype.$ajax = axios;  //修改ajax原型指向为 axios
import Qs from 'qs';
// import store from "element-ui/packages/cascader-panel/src/store";  // 引入Qs，这个库是axios里面包含的，不需要再下载了
import store from '@/store'
// 统一请求路径前缀

// // const base = '/crdp';
import {Base64} from 'js-base64'

// const base = '/ccma-server/api'   // 服务器地址/

// const api = process.env.NODE_ENV == 'development'?'/api':(location.href.indexOf('hkback.medinbd') == -1?'http://apitest.medinbd.com':'https://api.medinbd.com');   // http//
const api = process.env.NODE_ENV == 'development'? (location.href.indexOf('hkback.medinbd') == -1?'https://apitest.medinbd.com':'https://api.medinbd.com') : 'https://api.medinbd.com';   // http//

export const apiHttp = () => {
    // const http = process.env.NODE_ENV == 'development'?'/api':(location.href.indexOf('hkback.medinbd') == -1?'http://apitest.medinbd.com':'https://api.medinbd.com');   // http//
    const http = process.env.NODE_ENV == 'development'? (location.href.indexOf('hkback.medinbd') == -1?'https://apitest.medinbd.com':'https://api.medinbd.com') : 'https://api.medinbd.com';   // http//
    return http;
};

// 超时设定
axios.defaults.timeout = 30000;


axios.interceptors.request.use(config => {
    return config
}, err => {
    return Promise.resolve(err)
});
var that = this;
// http response 拦截器
axios.interceptors.response.use(response => {
    const data = response.data;
    // 根据返回的code值来做不同的处理(和后端约定)
	
	const _that = window._vm
	const route = _that.$route
	const router = _that.$router
	
    switch (data.code) {
        case 401:
            // 未登录 清除已登录状态
            localStorage.clear()
            sessionStorage.clear()
			_that.$store.dispatch('exit', false).then(() => {
			    router.push('/');
			});
            break;
        case 403:
            // 没有权限
            if (data.message !== null) {
            } else {
            }
            break;
        case 500:
            // 错误
            if (data.message !== null) {
            } else {
            }
            break;
        default:
            return data;
    }
    return data
}, (err) => {
    // 返回状态码不为200时候的错误处理


    return Promise.resolve(err)
});
//封装axios
const axiosPost = (url, data, type, headers, contentType, processData, async) => {
    if (store.state.isLogin) {//已登录添加token
		const token = localStorage.getItem('access_token');
        Object.assign(data, {access_token: token});
    }
    if (type == null || type == undefined) {
        type = "GET"
    }
    if (headers == null || headers == undefined) {
        headers = {}
    }
    if (contentType == null || contentType == undefined) {
        contentType = "application/x-www-form-urlencoded; charset=UTF-8"
    }
    if (processData == null || processData == undefined) {
        processData = true
    }
    if (async == null || async == undefined) {
        async = true
    }

    return axios({
        url: url,
        method: type,
        data: Qs.stringify(data),
        headers: {
            'Content-Type': contentType,
        },
        protocol: true,
        async: true
    })
};
//帳號登錄
export const loginConfirm = (data) => {
    return axiosPost(api + '/v1/back/login/', {data: window.btoa(JSON.stringify(data))}, 'post');
};
//帳號登錄
export const sendCode = (data) => {
    return axiosPost(api + '/v2/user/sendSms/', {data: Base64.encode(JSON.stringify(data))}, 'post');
};
//获取验证码 参数一：账号  参数二：验证码类型(1.手机号注册 2 手机找回密码 3 设置邮箱通知 90.邮箱注册 91.邮箱找回密码)
export const getVerifyCode = (data) => {
    return axiosPost(api + '/v1/user/sendsms/', data, 'post');
};
//套餐開通
export const packageOpen = (data) => {
    return axiosPost(api + '/v1/back/open/', { data: encodeURIComponent(JSON.stringify(data)) }, 'post');
};
//開通紀錄
export const recordOfOpening = (data) => {
    return axiosPost(api + '/v1/back/orderList/', {data: window.btoa(JSON.stringify(data))}, 'post');
};
//后台获取报告
export const getReport = (data) => {
    return axiosPost(api + '/v1/back/list/', {data: window.btoa(JSON.stringify(data))}, 'post');
};

//预约信息调取
export const getbookingInfo = (data) => {
    return axiosPost(api + '/v1/back/appointList/', {data: window.btoa(JSON.stringify(data))}, 'post');
};
//店鋪信息
export const addressList = () => {
    return axiosPost(api + '/v1/appoint/address/',{},'post');
}
//已确认预约
export const pushConfirmAxios = (data,id) => {
    return axiosPost(api + '/v1/back/confirm/'+id, data, 'post');
};
//下载预约信息表格
export const downExcelAxios = (data) => {
    return axiosPost(api + '/v1/back/export/', data, 'post',null ,'multipart/form-data');
};
//上傳文件
export const postFile = (data) => {
    return axiosPost(api + '/v1/back/upload/', data, 'post', null, 'application/x-www-form-urlencoded');
};
//获取套餐价格
export const packagePrice = () => {
	return axiosPost(api + '/v1/user/package/',{},'post');
}

// 设置邮箱体型
export const emailNotice = (data) => {
	return axiosPost(api + '/v1/back/setting/',data,'post');
}

//验证
//手机(大陆)
export const isPhone = (phonevalue) => {
    var phoneReg = /^1[3-578]\d{9}$/;
    if (phoneReg.test(phonevalue)) {
        return true;
    } else {
        return false;
    }
};
//手机(香港)
export const isHKPhone = (phonevalue) => {
    var reg = /^\d{8}$/;
    if (reg.test(phonevalue)) {
        return true;
    } else {
        return false;
    }
};
//邮箱
export const isEmail = (emailValue) => {
	var mailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
	if(mailReg.test(emailValue)){
		return true;
	}else{
		return false;
	}
}


//预约信息调取
export const getVaccin = (data) => {
    return axiosPost(api + '/v3/back/apptList/', {data: window.btoa(JSON.stringify(data))}, 'post');
};


//获取报告列表
export const getReportList = (data) => {
    return axiosPost(api + '/v1/analysis/list/', data, 'post');
};

//问卷调查提交  参数：报告ID
export const  newQuestionsSubmit = (data) => {
	return axiosPost(api + '/v1/back/health/', { data: Base64.encode(JSON.stringify(data)) },'post');
}


//优惠码
export const getCoupon = (data) => {
	return axiosPost(api + '/v1/back/coupon/', { data: encodeURIComponent(JSON.stringify(data)) }, 'post');
}

//商品信息 
export const getGoodsList = (data) => {
	return axiosPost(api + '/v1/goods/list/', data, 'post');
}

//商品信息 
export const getGoods = (data) => {
	return axiosPost(api + '/v1/back/goods/', { data: encodeURIComponent(JSON.stringify(data)) }, 'post');
}

//留言 
export const getComment = (data) => {
	return axiosPost(api + '/v1/back/comment/', { data: window.btoa(JSON.stringify(data)) }, 'post');
}

//订单 
export const getOrder = (data) => {
	return axiosPost(api + '/v1/back/order/', { data: window.btoa(JSON.stringify(data)) }, 'post');
}
//问卷调查提交  参数：报告ID
function m22Submit(data){
	return AjaxPack(api + '/v1/back/healthM22/', { data: window.btoa(JSON.stringify(data)) },'post');
}



//数据统计
export const getStatistics = (data) => {
	return axiosPost(api+'/v1/admin/tongji/', { data: window.btoa(JSON.stringify(data)) }, 'post');
}


// 获取管理员列表
export const getAdminList = (data) => {
    return axiosPost(api+'/v1/back/admin/',{ data: Base64.encode(JSON.stringify(data)) } ,'post');
};

//选择项目
export const adminCompany = (data) => {
    return axiosPost(api+'/v1/back/company/', { data: Base64.encode(JSON.stringify(data)) } ,'post');
};

// 角色 列表 添加和修改 修改查询
export const adminRole = (data) => {
    return axiosPost(api+'/v1/back/adminRole/', { data: Base64.encode(JSON.stringify(data)) } ,'post');
};


// 菜单
// 列表 添加和修改(修改参数含id) 修改查询
export const adminMenu = (data) => {
    return axiosPost(api+'/v1/back/adminMenu/',{ data: Base64.encode(JSON.stringify(data)) } ,'post');
};



